import { View } from 'react-native';

import {
  IngredientCardImage,
  IngredientCardLabel,
  IngredientCardLabelContainer,
  IngredientCardNoticeLabel,
  IngredientCardPressable,
  IngredientCardQuantity,
  IngredientCardQuantityStepper,
} from './components';

export const IngredientCardV2 = {
  Pressable: IngredientCardPressable,
  Image: IngredientCardImage,
  ImageContainer: View,
  LabelContainer: IngredientCardLabelContainer,
  Label: IngredientCardLabel,
  NoticeLabel: IngredientCardNoticeLabel,
  Quantity: IngredientCardQuantity,
  QuantityStepper: IngredientCardQuantityStepper,
};
